import React, { Component } from 'react';

import MarkdownText from '../MarkdownText';

import './VideoBlock.css';

export default class VideoBlock extends Component {
  componentDidMount() {
    if (this.videoEl && this.videoEl.controlsList) {
      this.videoEl.controlsList.add('nodownload', 'nofullscreen');
    }
  }

  shouldComponentUpdate(nextProps) {
    return false;
  }

  render() {
    const video = this.props.video;

    if (!video || !video.fileName) return null;

    const { fileName, caption, width, height } = this.props.video;

    return (
      <div className="VideoBlock">
        <div
          className="VideoBlock__player"
          style={{
            paddingTop: `${100 * height / width}%`,
          }}
        >
          <video
            onClick={() => {
              if (
                this.videoEl.currentTime > 0 &&
                !this.videoEl.paused &&
                !this.videoEl.ended
              ) {
                this.videoEl.pause();
              } else {
                this.videoEl.play();
              }
            }}
            poster={`${process.env.PUBLIC_URL}/videos/${fileName}.jpg`}
            className="VideoBlock__video"
            ref={el => (this.videoEl = el)}
            controls
          >
            <source
              src={`${process.env.PUBLIC_URL}/videos/${fileName}.webm`}
            />
            <source
              src={`${process.env.PUBLIC_URL}/videos/${fileName}.mp4`}
            />
          </video>
        </div>
        {caption && (
          <div className="VideoBlock__caption">
            <MarkdownText text={caption} />
          </div>
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/timeline/VideoBlock.js